import React, { useEffect, useRef, useState } from 'react';
import styles from './UploadInput.module.scss';
import UploadIcon from '../../../../assets/icons/vector/UploadIcon.svg';
import CloseIcon from '../../../../assets/icons/vector/close-red.svg';
import Modal from 'component/hoc/modal/Modal';

const FileUploadPreview = ({
  inputID,
  style,
  placeholder = '',
  label = '',
  isImage = false,
  onChange,
  name = '',
  handleRemoveTempLogin = () => {},
  image,
  imageContentType,
  subContainerStyle,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [files, setFiles] = useState([]);
  const [modalImage, setModalImage] = useState(null);
  const fileInputRef = useRef(null);
  const [showModal, setShowModal] = useState(false);

  const handleFileChange = (event) => {
    onChange(event);
    const selectedFiles = Array.from(event.target.files);
    const filePreviews = selectedFiles.map((file) => {
      return {
        file,
        preview: file.type.startsWith('image/')
          ? URL.createObjectURL(file)
          : null,
      };
    });

    setFiles([...filePreviews]);
  };

  const handleRemoveFile = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const droppedFiles = Array.from(event.dataTransfer.files);
    const filePreviews = droppedFiles.map((file) => {
      return {
        file,
        preview: file.type.startsWith('image/')
          ? URL.createObjectURL(file)
          : null,
      };
    });
    setFiles([...files, ...filePreviews]);
  };

  useEffect(() => {
    setInputValue(imageContentType);
  }, [imageContentType]);

  const openModal = (image) => {
    setModalImage(image);
    setShowModal(true);
  };

  const closeModal = () => {
    setModalImage(null);
  };

  const hexToDataUrl = (hex, mimeType) => {
    const byteArray = new Uint8Array(
      hex.match(/.{1,2}/g).map((byte) => parseInt(byte, 16))
    );
    const base64String = btoa(String.fromCharCode(...byteArray));
    return `data:${mimeType};base64,${base64String}`;
  };

  const openFileInput = () => {
    fileInputRef.current.click();
  };

  return (
    <div className={`${styles['flex-container']}`} style={style}>
      {label && <label className={`${styles['label']}`}>{label}</label>}
      <input
        type='file'
        name={name}
        id={inputID}
        ref={fileInputRef}
        accept={isImage ? 'image/*' : 'image/*, .pdf, .doc, .docx, .xls, .xlsx'}
        onChange={handleFileChange}
        className={styles['file-input']}
      />

      <div className={`${styles['sub-container']}`} style={subContainerStyle}>
        <img
          src={UploadIcon}
          className={styles['icon']}
          onClick={openFileInput}
        />
        <label className={styles['filename']}> </label>
        <label className={styles['view']}> </label>

        {!files.length && !inputValue ? (
          <label htmlFor={inputID} className={styles['placeholder']}>
            {placeholder}
          </label>
        ) : !files.length && inputValue ? (
          <div>
            <>
              <div className={styles['filename']}>
                Click view to display the image
              </div>
              <span
                className={styles['view']}
                onClick={() => openModal('loadImage')}
              >
                View
              </span>
            </>

            <img
              src={CloseIcon}
              className={styles['close']}
              onClick={() => {
                handleRemoveFile(0);
                setFiles([]);
                setInputValue();
                handleRemoveTempLogin();
              }}
            />
          </div>
        ) : (
          files.map((fileData, index) => (
            <div key={index}>
              {fileData.preview ? (
                <>
                  <div className={styles['filename']}>
                    {fileData.file.name && fileData.file.name.length > 25
                      ? fileData.file.name.substring(0, 25) + '...'
                      : fileData.file.name}
                  </div>
                  <span
                    className={styles['view']}
                    onClick={() => openModal(fileData.preview)}
                  >
                    View
                  </span>
                </>
              ) : (
                <div className={styles['filename']}>
                  {' '}
                  {fileData.file.name && fileData.file.name.length > 25
                    ? fileData.file.name.substring(0, 25) + '...'
                    : fileData.file.name}
                </div>
              )}
              <img
                src={CloseIcon}
                className={styles['close']}
                onClick={() => {
                  handleRemoveFile(index);
                  handleRemoveTempLogin();
                }}
              />
            </div>
          ))
        )}
      </div>
      {modalImage && (
        <Modal isOpen={showModal} onClose={closeModal} title='Preview'>
          <div className={styles['modal-content']}>
            {modalImage === 'loadImage' ? (
              <img
                src={
                  image instanceof File
                    ? URL.createObjectURL(image)
                    : `data:${imageContentType};base64,${image}`
                }
                alt='Base64 Preview'
                className={styles['modal-image']}
              />
            ) : (
              <img
                src={modalImage}
                alt='File Preview'
                className={styles['modal-image']}
              />
            )}
          </div>
        </Modal>
      )}
    </div>
  );
};

export default FileUploadPreview;
